"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Queue = void 0;
class Queue {
    constructor() {
        this.firstItem = null;
        this.lastItem = null;
        this.size = 0;
    }
    getSize() {
        return this.size;
    }
    isEmpty() {
        return this.size === 0;
    }
    enqueue(item) {
        const newItem = Queue.createItem(item);
        if (this.isEmpty()) {
            this.firstItem = newItem;
            this.lastItem = newItem;
        }
        else {
            this.lastItem.next = newItem;
            this.lastItem = newItem;
        }
        this.size += 1;
    }
    dequeue() {
        let removedItem = null;
        if (!this.isEmpty()) {
            removedItem = this.firstItem.value;
            this.firstItem = this.firstItem.next;
            this.size -= 1;
        }
        return removedItem;
    }
    static createItem(value) {
        return {
            next: null,
            value,
        };
    }
}
exports.Queue = Queue;
